import { Circle, Mail, Clock, Filter, Zap, Layers, GitBranch, X, TrendingUp, DollarSign, Link2, Terminal } from "lucide-react";
export const BPMN_EVENT_TYPES = {
    none: {
        id: "none",
        labelKey: "bpmnEventTypes.none",
        descriptionKey: "bpmnEventTypes.none_description",
        icon: Circle,
        canBeStart: true,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "single"
    },
    message: {
        id: "message",
        labelKey: "bpmnEventTypes.message",
        descriptionKey: "bpmnEventTypes.message_description",
        icon: Mail,
        canBeStart: true,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "single"
    },
    timer: {
        id: "timer",
        labelKey: "bpmnEventTypes.timer",
        descriptionKey: "bpmnEventTypes.timer_description",
        icon: Clock,
        canBeStart: true,
        canBeIntermediate: true,
        canBeEnd: false,
        iconStyle: "single"
    },
    conditional: {
        id: "conditional",
        labelKey: "bpmnEventTypes.conditional",
        descriptionKey: "bpmnEventTypes.conditional_description",
        icon: Filter,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: false,
        iconStyle: "single"
    },
    signal: {
        id: "signal",
        labelKey: "bpmnEventTypes.signal",
        descriptionKey: "bpmnEventTypes.signal_description",
        icon: Zap,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "single"
    },
    multiple: {
        id: "multiple",
        labelKey: "bpmnEventTypes.multiple",
        descriptionKey: "bpmnEventTypes.multiple_description",
        icon: Layers,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "single"
    },
    parallelMultiple: {
        id: "parallelMultiple",
        labelKey: "bpmnEventTypes.parallelMultiple",
        descriptionKey: "bpmnEventTypes.parallelMultiple_description",
        icon: GitBranch,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: false,
        iconStyle: "single"
    },
    error: {
        id: "error",
        labelKey: "bpmnEventTypes.error",
        descriptionKey: "bpmnEventTypes.error_description",
        icon: X,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "single"
    },
    cancel: {
        id: "cancel",
        labelKey: "bpmnEventTypes.cancel",
        descriptionKey: "bpmnEventTypes.cancel_description",
        icon: X,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "double"
    },
    escalation: {
        id: "escalation",
        labelKey: "bpmnEventTypes.escalation",
        descriptionKey: "bpmnEventTypes.escalation_description",
        icon: TrendingUp,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "single"
    },
    compensation: {
        id: "compensation",
        labelKey: "bpmnEventTypes.compensation",
        descriptionKey: "bpmnEventTypes.compensation_description",
        icon: DollarSign,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: true,
        iconStyle: "double"
    },
    link: {
        id: "link",
        labelKey: "bpmnEventTypes.link",
        descriptionKey: "bpmnEventTypes.link_description",
        icon: Link2,
        canBeStart: false,
        canBeIntermediate: true,
        canBeEnd: false,
        iconStyle: "single"
    },
    terminate: {
        id: "terminate",
        labelKey: "bpmnEventTypes.terminate",
        descriptionKey: "bpmnEventTypes.terminate_description",
        icon: Terminal,
        canBeStart: false,
        canBeIntermediate: false,
        canBeEnd: true,
        iconStyle: "thick"
    }
};
export const getStartEventTypes = ()=>{
    return Object.values(BPMN_EVENT_TYPES).filter((event)=>event.canBeStart);
};
// Subset surfaced when users add a step input — intentionally narrower than
// the full intermediate set to keep authoring approachable.
export const SIMPLIFIED_INPUT_EVENT_IDS = [
    "none",
    "message",
    "timer"
];
export const getSimplifiedInputEventTypes = ()=>SIMPLIFIED_INPUT_EVENT_IDS.map((id)=>BPMN_EVENT_TYPES[id]);
export const getIntermediateEventTypes = ()=>{
    return Object.values(BPMN_EVENT_TYPES).filter((event)=>event.canBeIntermediate);
};
export const getEndEventTypes = ()=>{
    return Object.values(BPMN_EVENT_TYPES).filter((event)=>event.canBeEnd);
};
export const getBpmnEventIcon = (eventType)=>{
    return BPMN_EVENT_TYPES[eventType]?.icon || Circle;
};
export const getBpmnEventDefinition = (eventType)=>{
    return BPMN_EVENT_TYPES[eventType];
};

//# sourceMappingURL=bpmnEventTypes.js.map